module.exports = __webpack_public_path__ + "static/img/21.f605471.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/3/4/2/zh/21.png
// module id = UuWF
// module chunks = 0